'use client';

import { useEffect } from 'react';
import Script from 'next/script';

// BL-652: all three props are opt-in and default to what the SliceZone
// `hsa_message` block has always rendered — centred, hidden below `md`, and
// with its own top padding — so V1 is untouched. The V2 buy box card asks for
// left-aligned, visible at every width, and unpadded. Richard flagged each of
// them on PR #305: the message never appeared on mobile, and the `pt-2` was
// stacking on the card's own `gap-4`, giving that one row 24px where every
// other row gets 16px.
const HsaMessage = ({ align = 'center', hideOnMobile = true, padded = true }) => {
  const publicId = process.env.NEXT_PUBLIC_TRUEMED_PUBLIC_ID;

  useEffect(() => {
    if (window.TruemedProductPageLib) {
      window.TruemedProductPageLib.reloadWidget(false);
    }
  }, []);

  if (!publicId) return null;

  return (
    <>
      <div
        className={`${padded ? 'pt-2' : ''} ${
          hideOnMobile ? 'hidden md:flex' : 'flex'
        } ${align === 'center' ? 'justify-center' : 'justify-start'}`}
      >
        <div
          id="truemed-instructions"
          data-public-id={publicId}
          icon-height="18"
          style={{
            '--truemed-text-color': 'var(--color-primary)',
            '--truemed-link-color': 'var(--color-sea)',
            '--truemed-link-hover-color': 'var(--color-sea)',
          }}
        />
      </div>
      <Script
        src="https://static.truemed.com/widgets/merchant-pdp-widget.min.js"
        strategy="afterInteractive"
        onLoad={() => window.TruemedProductPageLib?.reloadWidget(false)}
      />
    </>
  );
};

export default HsaMessage;
